/**
 * 觸發瀏覽器下載 Blob（不開新分頁、不呼叫 window.print）。
 *
 * @param {Blob} blob
 * @param {string} [filename]
 */
export function triggerBlobDownload(blob, filename = 'download') {
  if (!(blob instanceof Blob)) {
    return;
  }

  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = filename;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(objectUrl);
}
